import { events } from "./constants";
import ga4 from "@/lib/tracking/ga4Core";
// import { trackGA4Event } from "./gaHelpers";

export const trackLoginEvent = ({ user } = {}) => {
  const eventName = events.USER_LOGIN;
  const eventParams = {
    method: "phone_number",
  };

  ga4.trackUserInteraction(eventName, eventParams);
  ga4.pushEvent({
    country_cd: "sa",
    language_cd: "ar",
    login_status: "logged in",
    user_id: user?.user_id,
  })
};

export const trackLogoutEvent = () => {
  const eventName = events.USER_LOGOUT;
  ga4.trackUserInteraction(eventName);
  ga4.pushEvent({
    country_cd: "sa",
    language_cd: "ar",
    login_status: "guest",
  })
};

export const trackSignupEvent = () => {
  const eventName = events.USER_SIGNUP;
  const eventParams = {
    method: "phone_number",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
